import { render } from "./SignInPCP.vue?vue&type=template&id=11d9324e"
import script from "./SignInPCP.vue?vue&type=script&lang=ts"
export * from "./SignInPCP.vue?vue&type=script&lang=ts"
script.render = render

export default script